/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseCompanyPromptDto } from '../../models/api-response-company-prompt-dto';

export interface SetCompanyAgentStatus$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  activate: boolean;
}

export function setCompanyAgentStatus(http: HttpClient, rootUrl: string, params: SetCompanyAgentStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseCompanyPromptDto>> {
  const rb = new RequestBuilder(rootUrl, setCompanyAgentStatus.PATH, 'patch');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.query('activate', params.activate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseCompanyPromptDto>;
    })
  );
}

setCompanyAgentStatus.PATH = '/api/ai-assistant/agent/status';
